(() => {
  const onReady = (callback) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  };

  const bindHomepageHeader = () => {
    const menuTrigger = document.querySelector(".headerNavLink.menu");
    const dropdownNav = document.querySelector("#dropdownNav");
    const dropdownItem = dropdownNav?.querySelector(".dropdownNavItem");
    const dropdownExit = document.querySelector("#dropdownExit");
    const tabs = Array.from(document.querySelectorAll(".dropdownNavItemControlsItem"));
    const panels = Array.from(document.querySelectorAll(".dropdownNavItemLinksGroup"));
    const slider = document.querySelector("#slider");
    const openers = Array.from(document.querySelectorAll(".openNav"));
    const closers = Array.from(document.querySelectorAll(".closeNav"));
    const mobileToggles = Array.from(document.querySelectorAll(".sliderNavDropdownToggle"));

    let menuCloseTimer = null;

    const activateTab = (tab, focusTab = false) => {
      if (!tab) {
        return;
      }

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle("active", isActive);
        item.setAttribute("aria-selected", String(isActive));
        item.setAttribute("aria-expanded", String(isActive));
        item.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      panels.forEach((panel) => {
        panel.classList.toggle("active", panel.id === tab.dataset.target);
      });

      if (focusTab) {
        tab.focus();
      }
    };

    const openMenu = () => {
      if (!menuTrigger || !dropdownItem || !dropdownExit || !dropdownNav) {
        return;
      }

      window.clearTimeout(menuCloseTimer);
      menuTrigger.classList.add("active");
      menuTrigger.setAttribute("aria-expanded", "true");
      dropdownItem.classList.add("active");
      dropdownExit.classList.add("active");
      dropdownNav.removeAttribute("inert");
    };

    const closeMenu = () => {
      if (!menuTrigger || !dropdownItem || !dropdownExit || !dropdownNav) {
        return;
      }

      menuTrigger.classList.remove("active");
      menuTrigger.setAttribute("aria-expanded", "false");
      dropdownItem.classList.remove("active");
      dropdownExit.classList.remove("active");
      dropdownNav.setAttribute("inert", "");
    };

    if (menuTrigger && dropdownItem && dropdownExit && dropdownNav && tabs.length && panels.length) {
      activateTab(tabs[0]);
      menuTrigger.addEventListener("mouseenter", openMenu);
      menuTrigger.addEventListener("click", () => {
        if (dropdownItem.classList.contains("active")) {
          closeMenu();
        } else {
          openMenu();
        }
      });
      dropdownExit.addEventListener("mouseenter", () => {
        menuCloseTimer = window.setTimeout(closeMenu, 150);
      });
      dropdownExit.addEventListener("click", closeMenu);
      dropdownNav.addEventListener("mouseenter", () => window.clearTimeout(menuCloseTimer));
      tabs.forEach((tab, index) => {
        tab.addEventListener("mouseenter", () => activateTab(tab));
        tab.addEventListener("focus", () => activateTab(tab));
        tab.addEventListener("click", () => activateTab(tab));
        tab.addEventListener("keydown", (event) => {
          let nextIndex = null;

          if (event.key === "Tab" && event.shiftKey) {
            event.preventDefault();
            menuTrigger.focus();
            return;
          }

          if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === "Home") {
            nextIndex = 0;
          } else if (event.key === "End") {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== null) {
            event.preventDefault();
            activateTab(tabs[nextIndex], true);
          }
        });
      });
      menuTrigger.addEventListener("keydown", (event) => {
        if (event.key === "Tab" && !event.shiftKey && dropdownItem.classList.contains("active")) {
          event.preventDefault();
          const activeTab = tabs.find((tab) => tab.classList.contains("active")) || tabs[0];
          activeTab.focus();
        }
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && dropdownItem.classList.contains("active")) {
          closeMenu();
          menuTrigger.focus();
        }
      });
      document.addEventListener("focusin", (event) => {
        if (!dropdownItem.classList.contains("active")) {
          return;
        }

        if (!menuTrigger.contains(event.target) && !dropdownNav.contains(event.target)) {
          closeMenu();
        }
      });
    }

    const openSlider = () => {
      if (!slider) {
        return;
      }

      if (typeof slider.showModal === "function") {
        if (!slider.open) {
          slider.showModal();
        }
      } else {
        slider.setAttribute("open", "");
      }

      document.body.classList.add("noScroll");
    };

    const closeSlider = () => {
      if (!slider) {
        return;
      }

      if (typeof slider.close === "function" && slider.open) {
        slider.close();
      } else {
        slider.removeAttribute("open");
      }

      document.body.classList.remove("noScroll");
    };

    openers.forEach((element) => {
      element.addEventListener("click", openSlider);
    });

    closers.forEach((element) => {
      element.addEventListener("click", closeSlider);
    });

    slider?.addEventListener("cancel", (event) => {
      event.preventDefault();
      closeSlider();
    });

    slider?.addEventListener("close", () => {
      document.body.classList.remove("noScroll");
    });

    slider?.addEventListener("click", (event) => {
      if (event.target === slider) {
        closeSlider();
      }
    });

    mobileToggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const expanded = toggle.classList.toggle("active");
        toggle.setAttribute("aria-expanded", String(expanded));
      });
    });
  };

  const bindPressCarousel = () => {
    const root = document.querySelector("#silmea-press-logos .logosSwiper");
    const track = root?.querySelector(".logosSwiperWrapper");

    if (!root || !track || track.dataset.overrideBound === "true") {
      return;
    }

    const originals = Array.from(track.children);
    if (originals.length < 2) {
      return;
    }

    track.dataset.overrideBound = "true";
    originals.forEach((node) => {
      const clone = node.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("tabindex", "-1");
      clone.querySelectorAll("img").forEach((img) => img.setAttribute("alt", ""));
      track.appendChild(clone);
    });

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    let loopWidth = 0;
    let offset = 0;
    let rafId = 0;
    let isPaused = false;

    const measure = () => {
      const gap = Number.parseFloat(window.getComputedStyle(track).gap || "0");
      loopWidth = originals.reduce((total, item, index) => {
        return total + item.getBoundingClientRect().width + (index < originals.length - 1 ? gap : 0);
      }, 0);
    };

    const step = () => {
      if (!isPaused && loopWidth > 0) {
        offset += window.innerWidth <= 800 ? 0.4 : 0.55;
        if (offset >= loopWidth) {
          offset = 0;
        }
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      }

      rafId = window.requestAnimationFrame(step);
    };

    const pause = () => {
      isPaused = true;
    };

    const resume = () => {
      isPaused = false;
    };

    root.addEventListener("mouseenter", pause);
    root.addEventListener("mouseleave", resume);
    root.addEventListener("focusin", pause);
    root.addEventListener("focusout", resume);

    window.addEventListener("resize", measure);
    measure();
    rafId = window.requestAnimationFrame(step);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      } else if (!rafId) {
        rafId = window.requestAnimationFrame(step);
      }
    });
  };

  onReady(() => {
    bindHomepageHeader();
    bindPressCarousel();
  });
})();
